(function () {
  if (window.__shHsliderInit) return;
  window.__shHsliderInit = true;

  var DOT_LABEL_TEMPLATE = (window.SH_I18N && window.SH_I18N.hslider_dot_label) || 'Ga naar item {n}';

  function setup(wrap) {
    var track = wrap.querySelector('[data-sh-hslider-track]');
    var prevBtn = wrap.querySelector('[data-sh-hslider-prev]');
    var nextBtn = wrap.querySelector('[data-sh-hslider-next]');
    var dotsWrap = wrap.querySelector('[data-sh-hslider-dots]');
    if (!track) return;

    function buildDots() {
      if (!dotsWrap) return;
      var cards = Array.prototype.slice.call(track.children);
      if (!cards.length) return;
      dotsWrap.innerHTML = '';
      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sh-hslider-dot';
        dot.setAttribute('aria-label', DOT_LABEL_TEMPLATE.replace('{n}', i + 1));
        dot.addEventListener('click', function () {
          card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsWrap.appendChild(dot);
      });
      updateActiveDot();
    }

    function updateActiveDot() {
      if (!dotsWrap) return;
      var cards = Array.prototype.slice.call(track.children);
      var dots = Array.prototype.slice.call(dotsWrap.children);
      if (!cards.length || !dots.length) return;
      var trackRect = track.getBoundingClientRect();
      var closest = 0;
      var closestDist = Infinity;
      cards.forEach(function (card, i) {
        var r = card.getBoundingClientRect();
        var dist = Math.abs(r.left - trackRect.left);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      dots.forEach(function (d, i) { d.classList.toggle('sh-on', i === closest); });
    }

    function checkScrollable() {
      var scrollable = track.scrollWidth > track.clientWidth + 4;
      wrap.classList.toggle('sh-has-scroll', scrollable);
      if (scrollable) buildDots();
      else if (dotsWrap) dotsWrap.innerHTML = '';
    }

    function step(dir) {
      var card = track.children[0];
      var amount = card ? card.getBoundingClientRect().width + 14 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateActiveDot, 80);
    }, { passive: true });

    checkScrollable();
    window.addEventListener('resize', checkScrollable);
  }

  document.querySelectorAll('[data-sh-hslider]').forEach(setup);
})();
